export const navLinks = [
  { label: "首页", href: "#top" },
  { label: "热门话题", href: "#topics" },
  { label: "推荐作品", href: "#works" },
  { label: "讨论专区", href: "#discussion" },
  { label: "粉丝圈子", href: "#circles" },
  { label: "常见问题", href: "#faq" },
  { label: "关于我们", href: "#about" },
];

export const hotTopics = [
  {
    id: "t1",
    tag: "剧情讨论",
    title: "新番《春山行》第一话剧情细节大家怎么看？",
    snippet: "开篇的伏笔埋得真妙，两位主角的初次对视是不是已经暗示了后续走向？",
    heat: 2864,
    replies: 182,
    author: "山间看雪人",
    color: "primary",
  },
  {
    id: "t2",
    tag: "安利分享",
    title: "求推荐校园向、结局圆满的完结作品",
    snippet: "最近想找些轻松治愈的校园题材，最好是结局甜甜的那种，评论区蹲一个。",
    heat: 2150,
    replies: 137,
    author: "汽水味薄荷",
    color: "accent",
  },
  {
    id: "t3",
    tag: "同人创作",
    title: "开个楼，一起给新角色脑补同人设定",
    snippet: "这个新登场的神秘角色太戳我了，大家觉得他背后藏着什么故事？",
    heat: 1932,
    replies: 98,
    author: "夜航星",
    color: "secondary",
  },
  {
    id: "t4",
    tag: "入坑指南",
    title: "刚入坑的萌新，求一份靠谱的补番路线",
    snippet: "不知道从哪部开始看比较好，想请老玩家帮忙排个顺序。",
    heat: 1708,
    replies: 121,
    author: "半糖去冰",
    color: "primary",
  },
  {
    id: "t5",
    tag: "角色人气",
    title: "本季度你最想给哪位角色投票？",
    snippet: "这个季度的角色都好有魅力，选一只你最想守护的！",
    heat: 1596,
    replies: 201,
    author: "月亮邮递员",
    color: "accent",
  },
  {
    id: "t6",
    tag: "圈内动态",
    title: "关于近期圈内活动的讨论与建议收集",
    snippet: "大家希望下一次同好见面会或者线上活动是什么形式？来聊聊。",
    heat: 1289,
    replies: 76,
    author: "晚风收集家",
    color: "secondary",
  },
];

export const works = [
  {
    id: "w1",
    title: "春山行",
    genre: "古风 · 仙侠",
    score: "9.4",
    status: "连载中",
    desc: "一场误入仙山的邂逅，让两个性格迥异的人在烟雨与剑影中相知相守。",
    chapters: "共 48 话",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20warm%20anime%20illustration%20of%20two%20elegant%20figures%20in%20flowing%20ancient%20chinese%20robes%20standing%20under%20cherry%20blossoms%20on%20a%20misty%20mountain%2C%20golden%20and%20rose%20warm%20color%20palette%2C%20soft%20dreamlike%20lighting%2C%20romantic%20atmosphere%2C%20ink%20wash%20background%2C%20editorial%20book%20cover%20art&width=640&height=860&seq=work-spring-mountain&orientation=portrait",
  },
  {
    id: "w2",
    title: "雨季来信",
    genre: "都市 · 治愈",
    score: "9.1",
    status: "已完结",
    desc: "每年雨季准时出现在信箱里的手写信，连接起两个陌生人的漫长温柔。",
    chapters: "共 36 话",
    cover: "https://readdy.ai/api/search-image?query=Warm%20stylized%20anime%20illustration%20of%20two%20silhouetted%20figures%20sharing%20an%20umbrella%20on%20a%20rainy%20neon%20city%20street%20at%20dusk%2C%20soft%20golden%20streetlight%20glow%2C%20rose%20and%20amber%20tones%2C%20cozy%20romantic%20mood%2C%20editorial%20book%20cover%20art&width=640&height=860&seq=work-rain-letter&orientation=portrait",
  },
  {
    id: "w3",
    title: "糖罐里的夏天",
    genre: "校园 · 青春",
    score: "9.0",
    status: "连载中",
    desc: "课桌下偷偷传递的纸条，操场边的心照不宣，是属于夏天的限定心动。",
    chapters: "共 52 话",
    cover: "https://readdy.ai/api/search-image?query=Soft%20warm%20anime%20illustration%20of%20two%20schoolboys%20in%20uniforms%20walking%20together%20along%20a%20sunlit%20cherry%20blossom%20path%20in%20summer%2C%20golden%20afternoon%20light%2C%20rose%20and%20cream%20palette%2C%20gentle%20nostalgic%20mood%2C%20editorial%20book%20cover%20art&width=640&height=860&seq=work-summer-candy&orientation=portrait",
  },
  {
    id: "w4",
    title: "星轨两端",
    genre: "科幻 · ABO",
    score: "8.8",
    status: "连载中",
    desc: "星际列车上的偶然相遇，让两个本不该有交集的人逐渐靠近彼此。",
    chapters: "共 40 话",
    cover: "https://readdy.ai/api/search-image?query=Warm%20futuristic%20anime%20illustration%20of%20two%20figures%20facing%20each%20other%20in%20a%20starlit%20space%20train%20corridor%2C%20soft%20golden%20and%20rose%20nebula%20light%20through%20windows%2C%20romantic%20science%20fiction%20mood%2C%20editorial%20book%20cover%20art&width=640&height=860&seq=work-star-track&orientation=portrait",
  },
  {
    id: "w5",
    title: "山茶与猫",
    genre: "日常 · 温馨",
    score: "9.2",
    status: "已完结",
    desc: "开在街角的花店与咖啡店，一人一猫一花，日子缓慢却足够滚烫。",
    chapters: "共 30 话",
    cover: "https://readdy.ai/api/search-image?query=Cozy%20warm%20anime%20illustration%20of%20two%20figures%20and%20a%20ginger%20cat%20in%20a%20small%20flower%20shop%20by%20a%20sunny%20window%2C%20camellia%20flowers%2C%20soft%20rose%20and%20honey%20tones%2C%20gentle%20peaceful%20daily%20life%20mood%2C%20editorial%20book%20cover%20art&width=640&height=860&seq=work-camellia-cat&orientation=portrait",
  },
  {
    id: "w6",
    title: "墨守城记",
    genre: "权谋 · 宫廷",
    score: "9.0",
    status: "连载中",
    desc: "朝堂之上的步步为营，两个少年在权谋旋涡里许下彼此的唯一。",
    chapters: "共 60 话",
    cover: "https://readdy.ai/api/search-image?query=Dramatic%20warm%20anime%20illustration%20of%20two%20figures%20in%20ornate%20ancient%20court%20robes%20standing%20in%20a%20candlelit%20palace%20hall%2C%20gold%20and%20crimson%20color%20palette%2C%20ink%20and%20shadow%2C%20intense%20romantic%20tension%2C%20editorial%20book%20cover%20art&width=640&height=860&seq=work-ink-city&orientation=portrait",
  },
  {
    id: "w7",
    title: "云端通信",
    genre: "轻科幻 · 甜",
    score: "8.7",
    status: "已完结",
    desc: "深夜电台里两个声音的温柔对谈，跨越城市与时差缓缓靠近。",
    chapters: "共 34 话",
    cover: "https://readdy.ai/api/search-image?query=Dreamy%20warm%20anime%20illustration%20of%20two%20figures%20with%20headphones%20in%20separate%20moonlit%20rooms%20connected%20by%20glowing%20radio%20waves%2C%20soft%20rose%20and%20gold%20night%20tones%2C%20gentle%20tender%20mood%2C%20editorial%20book%20cover%20art&width=640&height=860&seq=work-cloud-radio&orientation=portrait",
  },
  {
    id: "w8",
    title: "深海来信",
    genre: "奇幻 · 人鱼",
    score: "8.9",
    status: "连载中",
    desc: "一封来自深海的漂流瓶，把陆地少年与深海人鱼的命运缠绕在一起。",
    chapters: "共 44 话",
    cover: "https://readdy.ai/api/search-image?query=Enchanting%20warm%20anime%20illustration%20of%20two%20figures%20beneath%20a%20glowing%20aquamarine%20and%20rose%20underwater%20world%20with%20bioluminescent%20bubbles%2C%20soft%20golden%20light%20rays%2C%20mysterious%20romantic%20mood%2C%20editorial%20book%20cover%20art&width=640&height=860&seq=work-deep-sea&orientation=portrait",
  },
];

export const discussions = [
  {
    id: "d1",
    board: "剧情研究院",
    icon: "ri-quill-pen-line",
    desc: "深度拆解剧情走向、伏笔与人物弧光。",
    topics: 1240,
    posts: 35600,
  },
  {
    id: "d2",
    board: "安利俱乐部",
    icon: "ri-heart-3-line",
    desc: "把心头好安利给全世界，也接收同好的反向安利。",
    topics: 860,
    posts: 21800,
  },
  {
    id: "d3",
    board: "同人创作区",
    icon: "ri-palette-line",
    desc: "画手与写手的大本营，脑洞与笔触尽情碰撞。",
    topics: 1520,
    posts: 40200,
  },
  {
    id: "d4",
    board: "新手答疑站",
    icon: "ri-questionnaire-line",
    desc: "入坑指南、作品安利顺序、术语科普一站式解答。",
    topics: 540,
    posts: 9900,
  },
];

export const circles = [
  {
    id: "c1",
    name: "校园青春研究所",
    member: "12.6k",
    tag: "青春 · 治愈",
    desc: "专攻校园向作品，一起回忆青春里最亮的那束光。",
    cover: "https://readdy.ai/api/search-image?query=Warm%20anime%20illustration%20of%20a%20sunlit%20school%20courtyard%20with%20cherry%20blossom%20trees%20and%20two%20strolling%20students%2C%20soft%20golden%20afternoon%20glow%2C%20rose%20and%20cream%20palette%2C%20nostalgic%20youth%20mood&width=800&height=520&seq=circle-campus&orientation=landscape",
  },
  {
    id: "c2",
    name: "古风江湖议事阁",
    member: "9.8k",
    tag: "古风 · 仙侠",
    desc: "品茗论剑，细说那些跨越山海的侠骨与柔情。",
    cover: "https://readdy.ai/api/search-image?query=Warm%20anime%20illustration%20of%20an%20ancient%20chinese%20tea%20house%20by%20a%20misty%20lake%20with%20willow%20and%20lanterns%2C%20two%20robed%20figures%20at%20a%20table%2C%20ink%20wash%20and%20gold%2C%20rose%20and%20amber%20tones%2C%20poetic%20mood&width=800&height=520&seq=circle-ancient&orientation=landscape",
  },
  {
    id: "c3",
    name: "幻想宇宙漫游组",
    member: "7.4k",
    tag: "科幻 · ABO",
    desc: "畅游星辰大海，探索设定与世界观的无尽可能。",
    cover: "https://readdy.ai/api/search-image?query=Warm%20anime%20illustration%20of%20two%20figures%20gazing%20at%20a%20rosy%20golden%20nebula%20through%20a%20spaceship%20window%2C%20soft%20starlight%2C%20rose%20and%20honey%20tones%2C%20dreamy%20science%20fiction%20mood&width=800&height=520&seq=circle-scifi&orientation=landscape",
  },
  {
    id: "c4",
    name: "画手约稿市集",
    member: "5.2k",
    tag: "同人 · 约稿",
    desc: "约稿、改图、灵感碰撞，把喜欢变成看得见的画面。",
    cover: "https://readdy.ai/api/search-image?query=Cozy%20warm%20anime%20illustration%20of%20a%20cluttered%20illustrator%20desk%20with%20sketchbooks%2C%20tablet%20and%20warm%20desk%20lamp%20light%2C%20rose%20and%20honey%20tones%2C%20creative%20artistic%20mood&width=800&height=520&seq=circle-artist&orientation=landscape",
  },
];

export const faqs = [
  {
    q: "腐漫网是一个什么样的社区？",
    a: "腐漫网是一个面向腐向内容爱好者与同好人群的互动社区平台，大家在这里围绕感兴趣的作品、角色和话题展开讨论，交流剧情、分享安利、参与圈子互动，也能找到志同道合的朋友。",
  },
  {
    q: "我可以在这里分享自己的同人创作吗？",
    a: "当然可以。社区设有同人创作区，无论是文字脑洞还是绘画作品都欢迎分享。发布时请遵守平台规范，尊重原作者与原创者权益，并选择合适的分区与标签。",
  },
  {
    q: "第一次来，不知道从哪开始看怎么办？",
    a: "欢迎来到腐漫网！你可以先逛逛「热门话题」了解大家都在聊什么，再到「推荐作品」看看榜单，或者去「新手答疑站」提问，热心同好会第一时间为你解答。",
  },
  {
    q: "需要注册账号才能参与讨论吗？",
    a: "目前网站的浏览功能完全开放，无需注册即可浏览内容。后续如需参与发帖、评论与收藏等互动，可以关注平台的账号功能上线公告。",
  },
  {
    q: "社区对内容有哪些规范要求？",
    a: "为了给大家营造友好、安全的交流环境，社区要求所有内容遵守国家法律法规与平台守则，尊重他人，理性讨论，不发布违规、侵权或不友善的信息。",
  },
];

export const stats = [
  { value: "128万", label: "注册同好", icon: "ri-user-heart-line" },
  { value: "56万", label: "累计话题", icon: "ri-chat-3-line" },
  { value: "8200", label: "活跃圈子", icon: "ri-group-line" },
  { value: "24h", label: "全天候陪伴", icon: "ri-24-hours-line" },
];